import React from "react";
import { IconButton, InputAdornment, Tooltip } from "@mui/material";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import { PRIMARY } from "./constants";

const TOOLTIP_PROPS = { enterTouchDelay: 0, disableInteractive: true };

export function buildProfileInfoAdornment(tooltip) {
  if (!tooltip) return null;
  return (
    <InputAdornment position="end">
      <Tooltip title={tooltip} arrow placement="top" {...TOOLTIP_PROPS}>
        <IconButton
          size="small"
          edge="end"
          aria-label="Informazioni"
          tabIndex={-1}
          sx={{ p: 0.25, color: PRIMARY, pointerEvents: "auto", "&:hover": { bgcolor: "transparent" } }}
        >
          <InfoOutlined sx={{ fontSize: 18 }} />
        </IconButton>
      </Tooltip>
    </InputAdornment>
  );
}
